// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1oTFA","title":"styles_title__KjA6H"};